import {
  Row,
  Col,
  Card,
  Button,
} from 'antd';
import {
  InfoCircleOutlined,
} from '@ant-design/icons';
import './index.css';
import { Link, useParams } from 'react-router-dom';
import { getFixtures } from '../../apis/fixture.api';
import { Key, useEffect, useState } from 'react';
import {
  CATEGORY_LINKS,
  MAIN_EVENTS,
  PAGE_TITLES,
  categories,
} from '../../utils/constant';
import Loader from '../../components/common/Loader';
import Title from 'antd/es/typography/Title';
import { styles } from '../../styles';
import { useMediaQuery } from '../../hooks/MediaQuery.hook';
import { getTimer } from '../../utils/timer';
import MainDescription from '../Description';
import { getCategoryType } from '../../utils';

export default function Home() {
  const matches = useMediaQuery('(min-width: 1000px)');
  const [fixtures, setFixtures] = useState<any>({});
  const [noFixtures, setNoFixtures] = useState(false);
  const { soccer, categoryName } = useParams();
  const [loader, setLoader] = useState(false);
  // const buttonSize = matches ? 'large' : 'small';

  const getAllFixtures = async () => {
    setLoader(true);
    const newCat = soccer === 'home' ? 'soccer' : soccer;
    const categoryObj = categories.find((cat) => cat.label === categoryName);
    const category = categoryObj?.value ?? newCat;

    const response = await getFixtures({ categoryName: category });
    if (!response?.data?.subCategories[0]?.games?.length) {
      setNoFixtures(true);
    } else {
      setNoFixtures(false);
    }
    setFixtures(response.data);
    setLoader(false);
  };

  function SubCategoryCard({ subCategory }: any) {
    return (
      <Col style={{ marginBottom: '8px', justifyContent: 'center' }} span={24}>
        <Card
          size="small"
          title={
            <div style={styles.headerStyle}>
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#6a0707',
                  fontSize: '18px',
                  textTransform: 'capitalize',
                }}>
                {subCategory?.subCategoryImage ? (
                  <img
                    style={{ width: '30px', paddingRight: '10px' }}
                    src={subCategory?.subCategoryImage}
                    alt={subCategory?.subCategoryName}
                    loading="lazy"
                  />
                ) : (
                  <InfoCircleOutlined style={styles.iconStyle} />
                )}
                <span
                  className={
                    MAIN_EVENTS.includes(subCategory?.subCategoryName)
                      ? 'blinking-heading'
                      : ''
                  }>
                  {subCategory?.subCategoryName?.toUpperCase()}
                </span>
              </span>
            </div>
          }
          extra={
            !categoryName &&
            CATEGORY_LINKS[subCategory?.subCategoryName?.toUpperCase()] && (
              <Link
                to={`${CATEGORY_LINKS[subCategory?.subCategoryName?.toUpperCase()]}`}
                style={styles.more}
                className="more">
                More
              </Link>
            )
          }
          style={styles.cardStyle}>
          <Row gutter={24}>
            {subCategory?.games?.map((fixture: any, index: Key | null | undefined) => (
              <Col span={12} key={index}>
                <FixtureCard
                  key={index}
                  fixture={{
                    ...fixture,
                    subCategoryName: subCategory?.subCategoryName,
                  }}
                />
              </Col>
            ))}
          </Row>
        </Card>
      </Col>
    );
  }

  function Timer({ timerValue }: any) {
    return <strong style={timerValue === 'Live' ? { color: 'red' } : {}}>{timerValue}</strong>;
  }

  function FixtureCard({ fixture }: any) {
    const matchPath = fixture?.teamB
      ? `/fixture/${fixture.teamA}-vs-${fixture.teamB}`
      : `/fixture/${fixture.teamA}`;

    return (
      <Link to={matchPath} rel="noopener noreferrer">
        <article className="fixture-card">
          <header className="fixture-link">
            <div className="category">
              <p>{getCategoryType(fixture?.subCategoryName)}</p>
              <p className="dash"></p>
            </div>
            <div className="flex-display">
              {matches ? (
                <>
                  <p className="team-name">
                    <span>
                      <img
                        className="fixture-image"
                        loading="lazy"
                        src={fixture.teamAImage}
                        alt={`${fixture?.subCategoryName} - ${fixture.teamA}`}
                      />
                    </span>
                    <strong>{fixture.teamA}</strong>
                  </p>
                  {fixture?.teamB && <p className="verses">vs</p>}
                  {fixture?.teamB && (
                    <p className="team-name">
                      <strong>{fixture.teamB}</strong>
                      <span>
                        <img
                          className="fixture-image"
                          loading="lazy"
                          src={fixture.teamBImage}
                          alt={`${fixture?.subCategoryName} - ${fixture.teamB}`}
                        />
                      </span>
                    </p>
                  )}
                </>
              ) : (
                <div>
                  <p className="team-name" style={{ margin: '0px' }}>
                    <img
                      className="fixture-image"
                      loading="lazy"
                      src={fixture.teamAImage}
                      alt={`${fixture?.subCategoryName} - ${fixture.teamA}`}
                    />
                    <strong>{fixture.teamA}</strong>
                  </p>
                  {fixture?.teamB && <p className="verses" style={{ margin: '0px' }}>vs</p>}
                  {fixture?.teamB && (
                    <p className="team-name" style={{ margin: '0px' }}>
                      <img
                        className="fixture-image"
                        loading="lazy"
                        src={fixture.teamBImage}
                        alt={`${fixture?.subCategoryName} - ${fixture.teamB}`}
                      />
                      <strong>{fixture.teamB}</strong>
                    </p>
                  )}
                </div>
              )}
            </div>
          </header>
          <p className="match-time">
            <Timer timerValue={getTimer(fixture)} />
          </p>
        </article>
      </Link>
    );
  }

  useEffect(() => {
    const category = categoryName ?? soccer;
    document.title = category ? PAGE_TITLES[category.toUpperCase()] : PAGE_TITLES.WEBSITE_TITLE;
    getAllFixtures();
  }, [categoryName, soccer]);

  return (
    <>

      <header>
        <Title level={1} style={{color: '#fff', fontSize: matches ? '36px': '18px'}}>Sportsfeed24 - Multi Player High Quality Soccer Streams of the Day!</Title>
      </header>
{/* 
      <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
        <Col span={16} style={{ paddingRight: '12px' }}>
          <Row className="flex-display">
            <Space style={matches ? { marginBottom: '15px' } : { marginBottom: '5px', gap: '2px' }} wrap>
              <Link to={DEFAULT_LEAGUE_LINK}>
                <Button
                  className="button-timer"
                  style={{ backgroundColor: '#169C6F' }}
                  shape="round"
                  size={buttonSize}>
                  Top Leagues
                </Button>
              </Link>

              <Link to={DEFAULT_TEAM_LINK}>
                <Button
                  className="button-timer"
                  style={{ backgroundColor: 'rgb(107 104 104)' }}
                  shape="round"
                  size={buttonSize}>
                  Top Teams
                </Button>
              </Link>
            </Space>
          </Row>
        </Col>
      </Row> */}

      <Row gutter={24} style={{ display: 'flex', justifyContent: 'center' }}>
        <Col span={matches ? 20 : 16} style={{ marginTop: '12px' }}>
          {categoryName && noFixtures ? (
            <div>
              <Title level={3}>No Fixtures Found For {categoryName}</Title>
              <Title level={3}>
                <Link to="/">
                  <Button style={styles.homeButton}>Home</Button>
                </Link>
              </Title>
            </div>
          ) : (
            fixtures?.subCategories?.map((subCategory: { games: string | any[]; }, index: any) =>
              subCategory?.games?.length > 0 ? (
                <SubCategoryCard key={index} subCategory={{ ...subCategory }} />
              ) : null
            )
          )}
        </Col>
      </Row>

      <Row gutter={24} style={{ display: 'flex', justifyContent: 'center' }}>
        <Col span={matches ? 20 : 16}>
          {!loader && !categoryName && !soccer && <MainDescription />}
        </Col>
      </Row>

      {loader && <Loader />}
    </>
  );
}
